module.exports = __webpack_public_path__ + "media/images/icons/icon_facebook-93a2b93fe6e9ef72368cca01583be19e.svg";